var path = 'src/app/forms/fields/boolean-field.html';
var html = "<select frm-model frm-required ng-model=model ng-required=required() ng-options=\"x.value as x.label for x in options\" class=form-control> <option></option> </select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/boolean-field.html
 ** module id = 249
 ** module chunks = 0
 **/